import React, { useContext } from 'react'
import { Form } from 'antd'
import { RichTextEditor } from 'packages/components/RichText'
import { EditProductQuestionItemProps } from '../../types'
import { debounce } from '@seiue/util'
import { editSubQuestion } from '../../utils'
import { EditPaperContext } from '@/features/test-paper/pages/EditPaper/context'

export const EditSubAnalyze: React.FC<EditProductQuestionItemProps> = ({
  curQuestion,
  subQuestions,
  setSubQuestions,
  treeNodeId,
}) => {
  const { limitLevel } = useContext(EditPaperContext)
  return (
    <Form.Item
      label={'解析'}
      required
      rules={[{ required: true, message: '请输入解析' }]}
    >
      <RichTextEditor
        readOnly={limitLevel > 2}
        minHeight={64}
        value={curQuestion.analysis || undefined}
        onChange={debounce((v) => {
          const newSubQuestions = editSubQuestion(
            subQuestions,
            treeNodeId || 0,
            { analysis: v }
          )
          setSubQuestions(newSubQuestions)
        }, 500)}
        excludeKeys={[
          'headerSelect',
          'group-upload',
          'insertLink',
          'fullScreen',
        ]}
        insertKeys={{
          index: 17,
          keys: ['uploadImage', 'insertFormula'],
        }}
      />
    </Form.Item>
  )
}
